export const DRAWER_WIDTH = 1000;
export const TABLE_HEIGHT = undefined;
